import React from 'react';
import { PillUnit } from '@mark43/cad-api';
import { EventPanelUnitsContext } from './event-panel-units-context';

export function useEventPanelUnits(): PillUnit[] {
    const value = React.useContext(EventPanelUnitsContext);
    if (!value) throw new Error('Unexpectedly could not find EventPanelUnitsContext value');
    return value;
}
